import { ListItemText } from '@mui/material';
import Box from '@mui/material/Box';
// using native img element for logo
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';

export const SidebarContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'sidebarWidth',
})<{ sidebarWidth: number }>(({ theme, sidebarWidth }) => ({
  width: sidebarWidth,
  flexShrink: 0,
  transition: 'width 0.2s ease',
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: theme.palette?.background?.paper ?? 'transparent',
  overflowX: 'hidden',
  overflowY: 'hidden',
  borderRadius: 12,
  flexGrow: 1,
}));

export const NavItemButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  borderRadius: collapsed ? 30 : 20,
  marginBottom: theme.spacing(1),
  minHeight: 44,
  display: 'flex',
  alignItems: 'center',
  justifyContent: collapsed ? 'center' : 'flex-start',
  paddingLeft: collapsed ? theme.spacing(0.5) : theme.spacing(0.5),
  paddingRight: collapsed ? theme.spacing(0.5) : theme.spacing(0.5),
  color: '#5F6285',
  fontSize: 12,
  '&:hover': {
    backgroundColor: theme.palette?.secondary?.light ?? 'rgba(0,0,0,0.08)',
    color: theme.palette?.primary?.dark ?? '#fff',
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette?.brandNavActiveBg ?? 'rgba(0,0,0,0.08)',
    color: theme.palette?.primary?.dark ?? '#fff',
    border: `1px solid ${theme.palette?.primary?.light ?? '#fff'}`,

    '& .MuiListItemIcon-root': {
      color: theme.palette?.primary?.main ?? '#fff',
    },
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.16)',
    },
  },
}));

export const NavItemIcon = styled(ListItemIcon, {
  shouldForwardProp: (prop) => prop !== 'collapsed' && prop !== 'isActive',
})<{ collapsed: boolean; isActive: boolean }>(({ collapsed }) => ({
  minWidth: collapsed ? 0 : 36,
  justifyContent: 'center',
  color: 'inherit',
  svg: {
    color: 'inherit',
    flexShrink: 0,
  },
}));

export const ToggleIconWrapper = styled('div')({
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#5F6285',
});

export const SidebarToggleButton = styled(IconButton)({
  color: 'rgba(0,0,0,0.4)',
  '&:hover': {
    color: 'rgba(0,0,0,0.8)',
    backgroundColor: 'rgba(0,0,0,0.04)',
  },
});

export const SidebarList = styled(List, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  paddingLeft: collapsed ? theme.spacing(1.5) : theme.spacing(2),
  paddingRight: collapsed ? theme.spacing(1.5) : theme.spacing(1.5),
  paddingTop: theme.spacing(2),
  flexGrow: 1,
}));

export const NavText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  display: collapsed ? 'none' : 'block',
  '	.MuiListItemText-primary': {
    fontSize: '13px',
    fontWeight: 500,
  },
}));

export const SidebarHeader = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  paddingLeft: collapsed ? theme.spacing(5) : theme.spacing(2),
  paddingRight: collapsed ? theme.spacing(5) : theme.spacing(2),
  paddingTop: collapsed ? theme.spacing(2) : theme.spacing(0.5),
  paddingBottom: collapsed ? theme.spacing(2) : theme.spacing(0.5),
  borderBottom: '1px solid rgba(0,0,0,0.08)',
  minHeight: 65,
  display: 'flex',
  flexDirection: collapsed ? 'column' : 'row',
  alignItems: 'center',
  justifyContent: collapsed ? 'center' : 'space-between',
  gap: collapsed ? theme.spacing(1) : theme.spacing(0),
}));

export const AppLogo = styled('img')({
  height: 28,
  width: 'auto',
  padding: 0,
});

export const SidebarFooter = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  borderTop: '1px solid rgba(0,0,0,0.08)',
  padding: `${theme.spacing(1)} ${collapsed ? theme.spacing(0.5) : theme.spacing(1.5)}`,
}));

export const LogoutButton = styled(ListItemButton, {
  shouldForwardProp: (prop) => prop !== 'collapsed',
})<{ collapsed: boolean }>(({ theme, collapsed }) => ({
  borderRadius: theme.shape.borderRadius,
  minHeight: 44,
  justifyContent: collapsed ? 'center' : 'flex-start',
  paddingLeft: collapsed ? theme.spacing(1.5) : theme.spacing(0.5),
  paddingRight: collapsed ? theme.spacing(1.5) : theme.spacing(2),
  color: '#5F6285',
  '&:hover': {
    backgroundColor: 'rgba(239,68,68,0.08)',
    color: '#ef4444',
  },
}));
